/**
 * Full-page browser navigation to an (often external) URL.
 *
 * Extracted into its own module so callers, such as the OAuth consent screen
 * sending the user back to a third-party client's redirect_url, can be
 * unit-tested by mocking this module. window.location is not reliably stubbable
 * under jsdom, so spying on it directly throws.
 *
 * @module lib/hard-redirect
 */

/** Navigates the browser to `url` (full page load). */
export function hardRedirect(url: string): void {
  window.location.assign(url);
}
